import { DataResponse } from '@portal/common/types';

export const isValidDataResponse = (dataResponse: DataResponse | null): boolean =>
    !!(dataResponse && dataResponse.columns && dataResponse.columns.length && dataResponse.records);
